<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 class="font-family005">Solutions</h2>
            <ul class="font-family005">
                <li><a routerLink="/"><i class="bx bx-home"></i> Home</a></li>
                <li class="active">Solutions / Smart Card Solutions</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Details Area -->
<section class="services-details-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-content">
                    <h2 class="text-capitalize font-family005">Smart Card Based Driving Licence and
                        Registration Certificate for Tamilnadu State Transport Authority</h2>
                    <div class="services-content">
                         <div class="services-details-one">
                            <img src="assets/img/product/smartcard.jpg" alt="Image">
                        </div>
                        <!-- <p>BonTon Softwares Framework enables Cities to Build a City Level Digital Platform that can integrate City Data from various connected systems from across different departments and functions of the city and integrating all the information and actionable items onto a single City Operations Platform. Our platform provides rich visualisation , user friendly controls , graphical user interface and geospatial representation.</p> -->
                    </div>

                    <div class="services-content">
                        <h3 class="font-family005">Issuance of Smart Card Based Driving License and Registration Certificate in
                            Tamil Nadu</h3>
                        <!-- <p>
                            Smart city initiative is a revolutionary project initiated by the Government of India to transform the country’s urban landscape. We had the opportunity to provide our services to the smart cities initiative in Coimbatore and Vellore through the mission directorate for the implementation of smart cities in the state of Tamil Nadu under TUFIDCO (Tamilnadu Urban Finance and Infrastructure Development Corporation Ltd)
                        </p>  -->
                    </div>
                    <div>
                        <ul class="font-family004 px-4">
                            <li><i class="bx bx-check-circle text-c01"></i> Issuing nearly 25,000 smart card every day across Tamil Nadu in 145.</li>
                            <li><i class="bx bx-check-circle text-c01"></i> Implemented the Project under BOOT Model & Project is Operational since 2018.</li>
                            <li><i class="bx bx-check-circle text-c01"></i> Built IT Infrastructure in all the R.T.O across Tamil nadu which includes
                                Supply and Maintenance of Desktop Computers, Dye-Sublimations
                                Printers, Laser Printers, UPS, Networking Switch, Partition, False Ceiling
                                & Vinyl Flooring, Airconditioning etc.</li>
                            <li><i class="bx bx-check-circle text-c01"></i> Implementation of Asset & Ticket Management Software (To Maintain
                                nearly 5000 Nos of IT & Non IT assets in all the 145 RTO Offices</li>
                            <li><i class="bx bx-check-circle text-c01"></i> Implementation of Inventory Management Software (IMS) to track each
                                and every Smart card based DL and RC issued.</li>
                        </ul>
                    </div> 
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-sidebar">
                    <div class="services-category">
                        <ul class="font-family004">
                            <li class="active"><a routerLink="/smart-card">Smart Card Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/smart-city">Smart City and Safe City <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/vr-ar">VR / AR <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/enterprise-soln">Enterprise Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/marketing-soln">Marketing Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/web-app">Web / Mobile App <i class="bx bx-chevron-right"></i></a></li>
                        </ul>
                    </div>

                    <div class="services-pdf">
                        <ul class="font-family005">
                            <li><a href="assets/img/BT-CP.pdf"><i class="bx bxs-file-pdf"></i> Company Profile</a></li>
                        </ul>
                    </div>

                    <div class="services-contact mb-30">
                        <h3 class="font-family003">Contact us to do your new projects</h3>
                        <a routerLink="/contact" class="default-btn font-family005"><span>Contact Us</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details Area -->

